import { captchaKey } from '../helpers/globalConfig';

let initialized = false;
declare var grecaptcha: any;

const getCaptchaToken = async (action: string): Promise<string> => {
    if (action !== 'Authenticated' && action !== 'SharedPasscode') {
        return Promise.resolve('');
    }
    if (typeof grecaptcha === 'undefined') {
        return Promise.resolve('');
    }

    return new Promise((resolve, reject) => {
        grecaptcha.ready(() => {
            try {
                if (!initialized) {
                    grecaptcha.render('recaptcha-container', {
                        sitekey: captchaKey,
                        size: 'invisible',
                        callback: (token: string) => {
                            initialized = true;
                            resolve(token);
                        }
                    });
                    grecaptcha.execute();
                }
                else {
                    grecaptcha.reset();
                    grecaptcha.execute();
                    waitForToken(resolve, reject);
                }
            } catch (error) {
                reject(error);
            }
        });
    });
};

function waitForToken(resolve: (token: string) => void, reject: (error: Error) => void) {
    const maxAttempts = 300; // Maximum attempts before failing
    let attempts = 0;

    const checkToken = () => {
        const token = grecaptcha.getResponse();
        if (token) {
            resolve(token);
        } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(checkToken, 1000); // Poll every 1000ms
        } else {
            reject(new Error("Failed to get token"));
        }
    };

    checkToken();
}

const showBadge = () => setBadge(true);
const hideBadge = () => setBadge(false);

const setBadge = (visibility: boolean): void => {
    if (typeof grecaptcha === 'undefined') {
        return;
    }

    grecaptcha.ready(() => {
        const badges = document.getElementsByClassName('grecaptcha-badge');
        for (let i = 0; i < badges.length; i++) {
            const badge = badges[i] as HTMLElement;
            if (badge) {
                badge.style.visibility = visibility ? '' : 'hidden';
                badge.style.zIndex = '1';
            }
        }
    });
};

export {
    getCaptchaToken,
    showBadge,
    hideBadge
};
